import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import moment from "moment";
import { Bar, Doughnut, HorizontalBar, Line, Pie } from "react-chartjs-2";
import DateUtils from "../../../util/dateUtils";
import StringUtils from "../../../util/stringUtils";
function formatIsEmpty(format) {
    return format === null || format === "" || format === "None";
}
function formatEquals(format1, format2) {
    const format1IsEmpty = formatIsEmpty(format1);
    const format2IsEmtpy = formatIsEmpty(format2);
    return (format1IsEmpty && format2IsEmtpy) || format1 === format2;
}
// @ts-expect-error - TS7006 - Parameter 'reportData' implicitly has an 'any' type.
function getValuesFromColumn(filter, reportData, key) {
    let values = [];
    if (!reportData || !filter) {
        return [];
    }
    const valueColumnSetting = filter.filterChartSettings.find((fcs) => fcs.key === key);
    if (valueColumnSetting && filter.selectedColumns) {
        const valueSplit = valueColumnSetting.value.split("::");
        const valueColumnId = parseInt(valueSplit[0], 10);
        let valueRelationshipId = null;
        if (valueSplit.length > 1) {
            valueRelationshipId = parseInt(valueSplit[1], 10);
        }
        let format = null;
        if (valueSplit.length > 2) {
            format = valueSplit[2];
        }
        let valueColumn = null;
        if (valueRelationshipId) {
            valueColumn = filter.selectedColumns.find((sc) => sc.filterSourceColumn &&
                sc.filterSourceColumn.id === valueColumnId &&
                sc.filterSourceRelationship &&
                sc.filterSourceRelationship.id === valueRelationshipId &&
                formatEquals(sc.format, format));
        }
        else {
            valueColumn = filter.selectedColumns.find((sc) => sc.filterSourceColumn &&
                sc.filterSourceColumn.id === valueColumnId &&
                formatEquals(sc.format, format));
        }
        if (valueColumn) {
            let columnName;
            if (valueColumn.format !== null &&
                valueColumn.format !== "" &&
                valueColumn.format !== "None") {
                if (valueColumn.filterSourceRelationship) {
                    columnName = `${valueColumn.filterSourceRelationship.id}_${
                    // @ts-expect-error - TS2531 - Object is possibly 'null'.
                    valueColumn.filterSourceColumn.sqlColumnName}_${valueColumn.format.toLowerCase()}`;
                }
                else {
                    columnName = `${
                    // @ts-expect-error - TS2531 - Object is possibly 'null'.
                    valueColumn.filterSourceColumn.sqlColumnName}_${valueColumn.format.toLowerCase()}`;
                }
            }
            else if (valueColumn.filterSourceRelationship) {
                // @ts-expect-error - TS2531 - Object is possibly 'null'.
                columnName = `${valueColumn.filterSourceRelationship.id}_${valueColumn.filterSourceColumn.sqlColumnName}`;
            }
            else {
                // @ts-expect-error - TS2531 - Object is possibly 'null'.
                columnName = `${valueColumn.filterSourceColumn.sqlColumnName}`;
            }
            // Collect the values from the report data.
            // @ts-expect-error - TS7006 - Parameter 'row' implicitly has an 'any' type.
            values = reportData.map((row) => row[columnName]);
            // detect the different formats the show the correct string based on the value, e.g. 1=January
            if (valueColumn.format === "Month") {
                // @ts-expect-error - TS7006 - Parameter 'v' implicitly has an 'any' type.
                values = values.map((v) => v && DateUtils.getMonthDisplay3Letter(v));
            }
            else if (valueColumn.format === "DayOfWeek") {
                // @ts-expect-error - TS7006 - Parameter 'v' implicitly has an 'any' type.
                values = values.map((v) => v && DateUtils.getDayOfWeekName(v));
            }
            else if (valueColumn.format === "YearMonth") {
                values = values.map(
                // @ts-expect-error - TS7006 - Parameter 'v' implicitly has an 'any' type.
                (v) => v && DateUtils.getYearMonthDisplay(v.toString()));
            }
            else if (valueColumn.format === "YearQuarter") {
                values = values.map(
                // @ts-expect-error - TS7006 - Parameter 'v' implicitly has an 'any' type.
                (v) => v && DateUtils.getYearQuarterDisplay(v.toString()));
            }
            else if (valueColumn.format === "Date") {
                // @ts-expect-error - TS7006 - Parameter 'v' implicitly has an 'any' type.
                values = values.map((v) => moment(v).format("M/D/YY"));
            }
        }
    }
    return values;
}
const ReportChart = (props) => {
    const { filter, reportData } = props;
    if (!filter ||
        !filter.chartType ||
        !reportData ||
        !filter.filterChartSettings) {
        return "";
    }
    const values = getValuesFromColumn(filter, reportData, "Value");
    const total = values.reduce((v, prev) => prev + v, 0);
    const percentages = values.map((v) => Math.round((v / total) * 100));
    // Only show percentages if it makes sense for the chart type.
    const showPercentages = filter.chartType === "Pie" || filter.chartType === "Donut";
    const labels = getValuesFromColumn(filter, reportData, "Label").map((label, index) => {
        let calcLabel = "";
        if (label == null) {
            calcLabel = "(empty)";
        }
        else if (typeof label === "boolean") {
            calcLabel = label ? "Yes" : "No";
        }
        else {
            calcLabel = label;
        }
        if (showPercentages) {
            return ` ${calcLabel} (${percentages[index]}%)`;
        }
        return ` ${calcLabel}`;
    });
    if (filter.chartType === "Pie" || filter.chartType === "Donut") {
        const chartProps = {
            data: {
                datasets: [
                    {
                        data: values,
                        backgroundColor: [
                            "#d11141",
                            "#00b159",
                            "#00aedb",
                            "#f37735",
                            "#ffc425",
                            "#6db2db",
                            "#0ea7b5",
                            "#0c457d",
                            "#e8702a",
                            "#ffbe4f",
                        ],
                    },
                ],
                labels,
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                animation: { animateRotate: true },
                legend: {
                    position: "bottom",
                    labels: {
                        boxWidth: 12,
                    },
                },
            },
        };
        // When a pie/donut chart has a lot of labels, we need to make it slightly larger to accommodate space for all the labels.
        if (filter.chartType === "Pie") {
            return (_jsx("div", { className: "chart-wrap", children: _jsx("div", { style: { height: 280 + Math.max(labels.length - 10, 0) * 20 }, children: _jsx(Pie, Object.assign({}, chartProps)) }) }));
        }
        return (_jsx("div", { className: "chart-wrap", children: _jsx("div", { style: { height: 280 + Math.max(labels.length - 10, 0) * 20 }, children: _jsx(Doughnut, Object.assign({}, chartProps)) }) }));
    }
    if (filter.chartType === "BarVertical") {
        return (_jsx("div", { className: "chart-wrap", children: _jsx(Bar, { data: {
                    datasets: [
                        {
                            data: values,
                            backgroundColor: "#00b159",
                        },
                    ],
                    labels,
                }, options: {
                    legend: {
                        display: false,
                    },
                    responsive: true,
                    animation: { animateRotate: true },
                } }) }));
    }
    if (filter.chartType === "BarHorizontal") {
        return (_jsx("div", { className: "chart-wrap", children: _jsx(HorizontalBar, { data: {
                    datasets: [
                        {
                            data: values,
                            backgroundColor: "#00b159",
                        },
                    ],
                    labels: labels === null || labels === void 0 ? void 0 : labels.map((label) => StringUtils.truncate(label, 40)),
                }, options: {
                    legend: {
                        display: false,
                    },
                    tooltips: {
                        callbacks: {
                            title: ([tooltip]) => labels ? labels[tooltip.index] : "",
                        },
                    },
                    responsive: true,
                    animation: { animateRotate: true },
                } }) }));
    }
    if (filter.chartType === "Line" || filter.chartType === "Area") {
        return (_jsx("div", { className: "chart-wrap", children: _jsx(Line, { data: {
                    datasets: [
                        {
                            label: "",
                            fill: filter.chartType === "Area",
                            data: values,
                            backgroundColor: "#00b15955",
                            borderColor: "#00b159",
                        },
                    ],
                    labels,
                }, options: {
                    legend: {
                        display: false,
                    },
                    responsive: true,
                    animation: { animateRotate: true },
                } }) }));
    }
    return "";
};
export default ReportChart;
